import cx from "classnames";
import { UpgradeModal } from "features/recumbent/UpgradeModal";
import React from "react";
import styles from "./TriggerUpsellModal.scss";

export class TriggerUpsellModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { children, className, ...props } = this.props;
    const { showModal } = this.state;

    return (
      <React.Fragment>
        <div className={cx(styles.TriggerUpsellModal, className)} onClick={this.openModal}>
          {children}
        </div>
        {showModal && <UpgradeModal {...props} onRequestClose={this.closeModal} />}
      </React.Fragment>
    );
  }
}
